import { onEvent,onEventBeacon,onTalkingDataEvent } from './Performance';
import { BOM } from './BOM.js';
import { loadScript } from './loadScript.js';
import { setUniqueDeviceIdCookie,isNative } from './utils';
import { addTapEvent, hasClass, bubble } from './DOM.js';

//
function Tracker(event, label, params = {}) {
    const _event = event || 'no';
    this.event = _event;
    this.tryCount = 3;
    //
    setUniqueDeviceIdCookie();
    if (label) {
        if (typeof params === 'object') {
            onEvent(event, label, { ...params });
        } else {
            onEvent(event, label);
        }
    }
    if(!isNative()) {
        loadScript(`https://jic.talkingdata.com/app/h5/v1?appid=EF6EF1136C2E4B74B8F39CBC8ED64950&vn=Pokekara&vc=1.0.1`, () => {
            if (label) {
                if (typeof params === 'object') {
                    onTalkingDataEvent(event, label, { label: label, ...params });
                } else {
                    onTalkingDataEvent(event, label,{ label: label });
                }
            }
        });
    }
    addTapEvent(document.body, e => {
        bubble(
            e.target,
            elem => {
                if (hasClass(elem, 'jstracker')) {
                    return true;
                }
            },
            elem => {
                const paramstr = elem.getAttribute('param');
                if (paramstr) {
                    const param = new Function('return' + paramstr)();
                    onEventBeacon(param.event || _event, param.action || param.label);
                    onTalkingDataEvent(param.event || _event, param.action || param.label);
                }
            }
        );
    });
}

//
Tracker.prototype.track =async function(arg1, arg2, arg3) {
    if (arg3) {
        await onEvent(arg1, arg2, { ...arg3 });
        onTalkingDataEvent(arg1, arg2, { label: arg2,...arg3 });
    } else if (arg2) {
        if (typeof arg2 === 'object') {
            await onEvent(this.event, arg1, { ...arg2 });
            onTalkingDataEvent(this.event, arg1, { label: arg1,...arg2 });
        } else {
            await onEvent(arg1, arg2);
            onTalkingDataEvent(arg1, arg2, { label: arg2 });
        }
    } else {
        await onEvent(this.event, arg1);
        onTalkingDataEvent(this.event, arg1, { label: arg1 });
    }
};
Tracker.prototype.trackBeacon = function(arg1, arg2, arg3) {
    if (arg3) {
        onEventBeacon(arg1, arg2, { ...arg3 });
        onTalkingDataEvent(arg1, arg2, { label: arg2, ...arg3 });
    } else if (arg2) {
        if (typeof arg2 === 'object') {
            onEventBeacon(this.event, arg1, { ...arg2 });
            onTalkingDataEvent(this.event, arg1, { label: arg1, ...arg2 });
        } else {
            onEventBeacon(arg1, arg2);
            onTalkingDataEvent(arg1, arg2, { label: arg2 });
        }
    } else {
        onEventBeacon(this.event, arg1);
        onTalkingDataEvent(this.event, arg1, { label: arg1 });
    }
};
Tracker.prototype.trackTalkingData = function(arg1, arg2, arg3) {
    if (arg3) {
        onTalkingDataEvent(arg1, arg2, { label: arg2, ...arg3 });
    } else if (arg2) {
        if (typeof arg2 === 'object') {
            onTalkingDataEvent(this.event, arg1, { label: arg1, ...arg2 });
        } else {
            onTalkingDataEvent(arg1, arg2, { label: arg2 });
        }
    } else {
        onTalkingDataEvent(this.event, arg1, { label: arg1 });
    }
};

export { Tracker };
